"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageCard = exports.ErrorMessages = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var classnames_1 = __importDefault(require("classnames"));
var lodash_1 = require("lodash");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var MAX_FILENAME_LENGTH = 255;
var ErrorMessages;
(function (ErrorMessages) {
    ErrorMessages["EmptyNewName"] = "An image name cannot be empty";
    ErrorMessages["NewNameTooLong"] = "An image name cannot exceed more than 255 characters";
    ErrorMessages["ServerReturnsError"] = "Something went wrong, please try again later.";
})(ErrorMessages = exports.ErrorMessages || (exports.ErrorMessages = {}));
var ImageCard = (function (_super) {
    __extends(ImageCard, _super);
    function ImageCard(props) {
        var _this = _super.call(this, props) || this;
        _this.inputName = null;
        _this.errorMessage = "";
        _this.shouldShowError = false;
        _this.isNameInputFocused = false;
        _this.hasImageLoaded = false;
        _this.handleImageLoaded = function () {
            var url = _this.props.url;
            var img = new window.Image();
            img.onload = _this.setHasImageLoaded;
            img.src = url;
        };
        _this.setHasImageLoaded = function () {
            _this.hasImageLoaded = true;
        };
        _this.handleEditClick = function (event) {
            if (!_this.isNameInputFocused) {
                event.preventDefault();
            }
            _this.focusOnNameInput();
        };
        _this.focusOnNameInput = function () {
            if (!_this.isNameInputFocused && _this.imageNameInput.current) {
                _this.imageNameInput.current.focus();
            }
        };
        _this.stopFocusOnNameInput = function () {
            if (_this.isNameInputFocused && _this.imageNameInput.current) {
                _this.imageNameInput.current.blur();
            }
        };
        _this.onMouseLeaveImageCard = function () {
            if (_this.shouldShowError) {
                _this.hideErrorMessage();
                _this.inputName = _this.props.name;
                _this.stopFocusOnNameInput();
            }
        };
        _this.onFileNameChange = function (value) {
            _this.inputName = value;
            _this.hideErrorMessage();
        };
        _this.onDeleteImage = function () { return __awaiter(_this, void 0, Promise, function () {
            var _a, id, onDelete, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, id = _a.id, onDelete = _a.onDelete;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4, onDelete(id)];
                    case 2:
                        _b.sent();
                        return [3, 4];
                    case 3:
                        err_1 = _b.sent();
                        this.showErrorMessage(ErrorMessages.ServerReturnsError);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        }); };
        _this.onNameSubmit = function (event) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        return [4, this.saveName()];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); };
        _this.onInputFocus = function () {
            _this.isNameInputFocused = true;
        };
        _this.onInputBlur = function () { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isNameInputFocused = false;
                        this.hideErrorMessage();
                        return [4, this.saveName()];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); };
        _this.debounceInputBlur = (0, lodash_1.debounce)(_this.onInputBlur, 200);
        _this.saveName = function () { return __awaiter(_this, void 0, Promise, function () {
            var _a, id, onRename, err_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.inputName && this.inputName === this.props.name) {
                            return [2];
                        }
                        if (!this.inputName) {
                            this.showErrorMessage(ErrorMessages.EmptyNewName);
                            this.focusOnNameInput();
                            return [2];
                        }
                        if (this.inputName.length > MAX_FILENAME_LENGTH) {
                            this.showErrorMessage(ErrorMessages.NewNameTooLong);
                            this.focusOnNameInput();
                            return [2];
                        }
                        _a = this.props, id = _a.id, onRename = _a.onRename;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4, onRename(id, this.inputName)];
                    case 2:
                        _b.sent();
                        return [3, 4];
                    case 3:
                        err_2 = _b.sent();
                        this.showErrorMessage(ErrorMessages.ServerReturnsError);
                        return [2];
                    case 4:
                        if (this.imageNameInput.current) {
                            this.imageNameInput.current.blur();
                        }
                        return [2];
                }
            });
        }); };
        _this.onUseImage = function () {
            if (_this.isNameInputFocused) {
                return;
            }
            var _a = _this.props, id = _a.id, onUseImage = _a.onUseImage;
            onUseImage(id);
        };
        _this.inputName = props.name;
        _this.imageNameInput = react_1.default.createRef();
        return _this;
    }
    ImageCard.prototype.componentDidMount = function () {
        this.handleImageLoaded();
    };
    ImageCard.prototype.render = function () {
        var _a = this.props, id = _a.id, isFormEnabled = _a.isFormEnabled, isCheckboxSelected = _a.isCheckboxSelected, name = _a.name, url = _a.url, onDragStart = _a.onDragStart, onDragEnd = _a.onDragEnd, onCheckboxToggle = _a.onCheckboxToggle, onUseImage = _a.onUseImage, onRename = _a.onRename, onDelete = _a.onDelete;
        var draggable = !!onDragStart && !this.isNameInputFocused;
        return (react_1.default.createElement("div", { className: "image-card", onMouseLeave: this.onMouseLeaveImageCard },
            react_1.default.createElement("div", { className: (0, classnames_1.default)({
                    "image-card__image_loaded": this.hasImageLoaded,
                    "image-card__image": true,
                }), style: { backgroundImage: this.hasImageLoaded ? "url(".concat(url, ")") : "" } },
                react_1.default.createElement("div", { className: (0, classnames_1.default)({
                        "image-card__overlay": true,
                        "image-card__overlay--focused": this.isNameInputFocused,
                        "image-card__overlay--selected": isCheckboxSelected,
                    }), onDragStart: onDragStart, onDragEnd: onDragEnd, draggable: draggable },
                    isFormEnabled && (react_1.default.createElement("div", { className: (0, classnames_1.default)("image-card__overlay-top", tokens_1.darkTheme) },
                        onCheckboxToggle && (react_1.default.createElement("div", { className: "image-card__checkbox-container" },
                            react_1.default.createElement(kaleidoscope_1.Checkbox, { item: { id: id, label: name, value: "" }, isSelected: isCheckboxSelected, onChange: function (toggleKey, event) {
                                    onCheckboxToggle(id, event);
                                }, labelHidden: true, size: kaleidoscope_2.CheckboxSize.Large, theme: kaleidoscope_2.CheckboxTheme.Dark }))),
                        react_1.default.createElement("form", { onSubmit: this.onNameSubmit, className: "image-card__name-container" },
                            react_1.default.createElement(kaleidoscope_1.TextInput, { label: "Image name", className: "image-card__input", variant: !!onRename ? kaleidoscope_1.TextInputVariant.Underlined : kaleidoscope_1.TextInputVariant.Borderless, labelHidden: true, size: kaleidoscope_1.TextInputSize.Small, theme: kaleidoscope_1.TextInputTheme.Dark, onFocus: this.onInputFocus, onBlur: this.debounceInputBlur, value: this.inputName, onChange: this.onFileNameChange, ref: this.imageNameInput, error: this.shouldShowError ? this.errorMessage : undefined, readOnly: !onRename }),
                            react_1.default.createElement("div", { className: "image-card__buttons" },
                                !!onRename && (react_1.default.createElement(kaleidoscope_1.IconButton, { className: "image-card__rename", "aria-label": "Rename", icon: this.isNameInputFocused ? react_1.default.createElement(icons_1.Tick, { key: "tick" }) : react_1.default.createElement(icons_1.Edit, { key: "edit" }), onClick: this.handleEditClick, size: kaleidoscope_1.ButtonSize.Small, type: kaleidoscope_1.ButtonType.Tertiary })),
                                !!onDelete && (react_1.default.createElement(kaleidoscope_1.IconButton, { isDestructive: true, className: "image-card__delete", "aria-label": "Delete", icon: react_1.default.createElement(icons_1.Delete, null), onClick: this.onDeleteImage, size: kaleidoscope_1.ButtonSize.Small, type: kaleidoscope_1.ButtonType.Tertiary })))))),
                    !!onUseImage && (react_1.default.createElement("div", { className: "image-card__overlay-center", onClick: this.onUseImage },
                        react_1.default.createElement("div", { className: "image-card__use-image" },
                            react_1.default.createElement(kaleidoscope_1.Button, { size: kaleidoscope_1.ButtonSize.Small, type: kaleidoscope_1.ButtonType.Secondary }, "Use image"))))))));
    };
    ImageCard.prototype.hideErrorMessage = function () {
        this.shouldShowError = false;
    };
    ImageCard.prototype.showErrorMessage = function (errorMessage) {
        this.shouldShowError = true;
        this.errorMessage = errorMessage;
    };
    ImageCard.defaultProps = {
        isFormEnabled: true,
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], ImageCard.prototype, "inputName", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], ImageCard.prototype, "errorMessage", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], ImageCard.prototype, "shouldShowError", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], ImageCard.prototype, "isNameInputFocused", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], ImageCard.prototype, "hasImageLoaded", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Object)
    ], ImageCard.prototype, "handleImageLoaded", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Object)
    ], ImageCard.prototype, "setHasImageLoaded", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Object)
    ], ImageCard.prototype, "onMouseLeaveImageCard", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Object)
    ], ImageCard.prototype, "onFileNameChange", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Object)
    ], ImageCard.prototype, "onInputFocus", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Object)
    ], ImageCard.prototype, "onInputBlur", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Object)
    ], ImageCard.prototype, "saveName", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ImageCard.prototype, "hideErrorMessage", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], ImageCard.prototype, "showErrorMessage", null);
    ImageCard = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], ImageCard);
    return ImageCard;
}(react_1.default.Component));
exports.ImageCard = ImageCard;
